import { Truck, ShieldCheck, RotateCcw, Clock } from "lucide-react";

interface TrustBadge {
  icon: React.ElementType;
  label: string;
}

const DEFAULT_BADGES: TrustBadge[] = [
  { icon: Truck, label: "Ücretsiz Kargo" },
  { icon: ShieldCheck, label: "Güvenli Ödeme" },
  { icon: RotateCcw, label: "14 Gün İade" },
  { icon: Clock, label: "Hızlı Teslimat" },
];

export function TrustBadges() {
  return (
    <div className="contents sm:flex sm:flex-wrap sm:items-center sm:gap-x-4 sm:gap-y-2 sm:border-t sm:border-[var(--es-border-soft)] sm:py-3">
      {DEFAULT_BADGES.map((badge) => {
        const Icon = badge.icon;
        return (
          <div
            key={badge.label}
            className="flex min-w-0 items-center gap-1.5 rounded-[var(--sf-radius)] border border-[var(--es-border-soft)] bg-white px-2.5 py-2 text-xs text-[var(--es-text-muted)] sm:border-0 sm:bg-transparent sm:p-0"
          >
            <Icon className="w-4 h-4 shrink-0" />
            <span className="min-w-0 truncate">{badge.label}</span>
          </div>
        );
      })}
    </div>
  );
}
